// extracted by mini-css-extract-plugin
export var lightMode = "_17-0";